/*
 * Copyright (c) 2022 Well Solutions SRL. All Rights Reserved.
 * This software is the proprietary information of Well Solutions SRL.
 * Use is subject to license and non-disclosure terms
 */

import {AbstractResourceService, JsonApiListResourceMetadataBase, JsonApiResource} from "@irian-ro/abstract-resource";
import { HttpClient } from "@angular/common/http";
import {EnvironmentService} from "@irian-ro/util-environment";
import {RoleWithRightsDto} from "./models/role-with-rights-dto.model";
import {Observable} from "rxjs";
import {RoleWithRightsVo} from "./models/role-with-rights-vo.model";
import {Injectable} from "@angular/core";

@Injectable({providedIn: 'root'})
export class RoleResourceService extends AbstractResourceService<RoleWithRightsVo, RoleWithRightsDto, any, any>{

  constructor(httpClient: HttpClient,
              environmentService: EnvironmentService) {

    super(
      httpClient,
      environmentService.getEnvironmentProperty('rolesUrl'),
      RoleWithRightsVo,
      RoleWithRightsDto
    );
  }

  findRolesByUserUuid(userUuid: string): Observable<JsonApiResource<RoleWithRightsVo[], JsonApiListResourceMetadataBase>>{
    return <Observable<JsonApiResource<RoleWithRightsVo[], JsonApiListResourceMetadataBase>>>this.httpClient?.get(`${this.url}/user/${userUuid}`);
  }

  getTemplateFromOrigin(originRoleUuid: string): Observable<JsonApiResource<RoleWithRightsDto, any>>{
    return <Observable<JsonApiResource<RoleWithRightsDto, any>>>this.httpClient?.get(`${this.url}/template/origin/${originRoleUuid}`);
  }

}
